<script>
import cloneDeep from "lodash/cloneDeep";

function MapGender(gender) {
  if (gender === "MALE") {
    return "男";
  } else if (gender === "FEMALE") {
    return "女";
  } else if (gender === "男") {
    return "MALE";
  } else if (gender === "女") {
    return "FEMALE";
  } else {
    return "--";
  }
}

function MapRoles(roles) {
  switch (roles) {
    case "大区经理":
      return "ROLE_REGION_MANAGER";
    case "超级管理员":
      return "ROLE_SUPER_ADMIN";
    case "管理员":
      return "ROLE_ADMIN";
    case "广目视觉训练师":
      return "ROLE_GROUP_OPTOMETRIST";
    case "视觉训练师":
      return "ROLE_AGENT_OPTOMETRIST";
    case "主管":
      return "ROLE_STATION_MANAGER";
    case "医生":
      return "ROLE_DOCTOR";
    case "代理商":
      return "ROLE_AGENT";
    default:
      return "";
  }
}
export default {
  props: {
    formTitle: String,
    formInputArray: Array,
    commitlabel: String,
    defaultValue: Object,
    confirmButton: String,
    keyOperation: String,
    isSelectSingle: Boolean,
    ProvinceList: Array,
    agentList: Array,
    tabs: Array,
    alertItem: String
  },
  watch: {
    formInputArray: function(newVal, oldVal){
      this.inputArray = newVal
      this.defaultValue = {}
    },
    'form.initFlag': function(newVal) {
      if (this.alertItem) {
        this.alertText = (newVal && newVal.length > 0) ? '' : this.alertItem
      }
    }
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      setTimeout(() => {
        if (!/^1(3|5|7|8|9)\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }, 1000);
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("密码不能为空"));
      }
      if (value.length > 32) {
        return callback(new Error("密码长度不应超过32位"));
      }
    };
    const validateRepassword = (rule, value, callback) => {
      const oldPs = this.form.password;
      if (!value) {
        return callback(new Error("密码不能为空"));
      }
      if (value.length > 32) {
        return callback(new Error("密码长度不应超过32位"));
      }
      if (oldPs !== value) {
        return callback(new Error("两次密码输入不同"));
      }
    };
    const formData = {};
    const inputArray = this.formInputArray
      ? JSON.parse(JSON.stringify(this.formInputArray))
      : null;
    if (inputArray) {
      inputArray.forEach(o => {
        if (o.keyName === "districtProvince" && this.ProvinceList) {
          o.children = this.ProvinceList;
        }
        if (
          o.keyName === "districtCity" &&
          this.defaultValue &&
          this.defaultValue.districtProvince
        ) {
          let children = this.ProvinceList.filter(
            o => o.id === this.defaultValue.districtProvince
          )[0];
          o.children = children.sons.map(o => {
            return {
              label: o.name,
              keyName: o.id
            };
          });
        }
        if (o.keyName === "agentId") {
          if (this.defaultValue && this.defaultValue.districtCity) {
            let cityId = this.defaultValue.districtCity;

            let children = this.agentList.filter(o => {
              let isFilter = false;
              o.districts.forEach(o => {
                if (o.id === cityId) {
                  isFilter = true;
                }
              });
              return isFilter;
            });
            o.children = children;
          } else {
            o.children = this.agentList;
          }
        }

        if (o.type === "checkbox") {
          formData[o.keyName] = [];
          o.children.forEach(obj =>
            obj.checked ? formData[o.keyName].push(obj.label) : null
          );
        } else {
          formData[o.keyName] = undefined;
        }
        if (o.value) {
          formData[o.keyName] = o.value;
        }
      });
    }
    if (this.defaultValue) {
      for (let key in formData) {
        if (this.defaultValue[key]) {
          switch (key) {
            case "gender":
              formData[key] = MapGender(this.defaultValue[key]);
              break;
            case "role":
              formData[key] = MapRoles(this.defaultValue[key]);
              break;
            default:
              formData[key] = this.defaultValue[key];
          }
        }
      }
    }
    const confirmButtonText = this.confirmButton || "提交";
    const formLabelWidth = this.isSelectSingle ? "30px" : "100px";
    let alertText = this.alertItem;
    let activeItemList = [];
    let checkList = [];
    if (this.tabs && this.tabs.length > 0) {
      alertText = this.tabs[0].alert;
      activeItemList = this.tabs[0].itemList;
      checkList = [this.tabs[0].key];
    }
    return {
      form: formData,
      inputArray,
      confirmButtonText,
      formLabelWidth,
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "change"
          }
        ],
        companyName: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "change"
          }
        ],
        phone: [
          {
            required: true,
            validator: validateMobile,
            trigger: "change"
          }
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change"
          }
        ],
        role: [
          {
            required: true,
            message: "请选择职务",
            trigger: "blur"
          }
        ],
        birth: [
          {
            required: true,
            message: "请输入生日",
            trigger: "change"
          }
        ],
        visionDisease: [
          {
            required: true,
            message: "请选择患者类型",
            trigger: "change"
          }
        ],
        // contact: [
        //   {
        //     required: true,
        //     message: "请填写联系人",
        //     trigger: "change"
        //   }
        // ],
        // contactLocation: [
        //   {
        //     required: true,
        //     message: "请填写联系地址",
        //     trigger: "blur"
        //   }
        // ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ],
        repassword: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        districtProvince: [
          {
            required: true,
            message: "请选择省份",
            trigger: "blur"
          }
        ],
        districtCity: [
          {
            required: true,
            message: "请选择城市",
            trigger: "blur"
          }
        ],
        unitPrice: [
          {
            required: true,
            message: "请输入单价",
            trigger: "blur"
          }
        ],
        courseCount: [
          {
            required: true,
            message: "请输入疗程个数",
            trigger: "blur"
          }
        ],
        refundCourseCount: [
          {
            required: true,
            message: "请输入疗程个数",
            trigger: "blur"
          }
        ],
        regionName: [
          {
            required: true,
            message: "请输入大区名称",
            trigger: "blur"
          }
        ]
      },
      checkList,
      activeItemList,
      alertText
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = cloneDeep(this.form);
          if (this.checkList.length > 0) {
            formData.slectTab = this.checkList[0];
          }
          this.$emit(
            "submitForm",
            formData,
            this.keyOperation,
            this.defaultValue
          );
          this.$emit("close", this.keyOperation, "afterSubmit");
        } else {
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("close", this.keyOperation);
      this.form = null;
    },
    onSelectChange(key, event) {
      if (key === "districtProvince") {
        this.inputArray.forEach(item => {
          if (item.keyName === "districtCity") {
            let children = this.ProvinceList.filter(
              o => o.id === this.form.districtProvince
            )[0];
            if (children.sons) {
              item.children = children.sons.map(o => {
                return {
                  label: o.name,
                  keyName: o.id
                };
              });
            } else {
              item.children = children.children.map(o => {
                return {
                  label: o.label,
                  keyName: o.value
                };
              });
            }
          }
        });
        this.form.districtCity = null;
        if (this.form.agentId) {
          this.form.agentId = null;
        }
      } else if (key === "districtCity") {
        this.inputArray.forEach(item => {
          if (item.keyName === "agentId") {
            let cityId = this.form[key];
            let children = this.agentList.filter(o => {
              let isFilter = false;
              o.districts.forEach(o => {
                if (o.id === cityId) {
                  isFilter = true;
                }
              });
              return isFilter;
            });
            item.children = children;
          }
        });
        this.form.agentId = null;
      } else if (
        key === "courseCount" ||
        key === "unitPrice" ||
        key === "refundCourseCount"
      ) {
        let tempCount = this.form.courseCount || this.form.refundCourseCount;
        if (tempCount && this.form.unitPrice) {
          this.form.totalPrice = tempCount * this.form.unitPrice;
        }
      } else {
        if (event!=null){
          this.$emit(event, this.form[key])
        }
      }
    },
    getPlaceholder(label) {
      return `请选择${label || ""}`;
    },
    onSwitch(tab) {
      this.$refs["form"].resetFields();
      const goalTab = this.tabs.filter(o => o.key === tab)[0];
      if (goalTab && !goalTab.disabled) {
        this.checkList = [tab];
        this.alertText = goalTab.alert;
        this.activeItemList = goalTab.itemList;
      } else {
        this.$message({
          message: goalTab.disableReason,
          type: "warning"
        });
      }
    },
    onSelectValue(refName, value) {
      if (value === false && this.$refs[refName]) {
        const refObj = this.$refs[refName][0];
        refObj.blur();
      }
    }
  }
};
</script>

<template>
  <Dialog
    :btn-text="confirmButtonText"
    :title="formTitle"
    @confirm="submitForm('form')"
    @close="closeForm"
    class="DialogFormContent"
  >
    <div class="detailTab" v-if="tabs && tabs.length > 0">
      <div
        class="tab-cell"
        v-for="(item,index) in tabs"
        :key="item.key + index"
        @click="onSwitch(item.key)"
        :style="{'border-bottom': `${checkList.indexOf(item.key) > -1 ? '2px solid #00c1de': '1px solid #E6E6E6'}`, 'color': `${checkList.indexOf(item.key) > -1 ? '#00c1de': '#929292'}`}"
      >{{item.label}}</div>
    </div>
    <el-form
      :model="form"
      size="small"
      class="DialogForm"
      :rules="rules"
      ref="form"
      @keyup.enter.native="submitForm('form')"
    >
      <div v-for="item in inputArray" :key="item.keyName">
        <el-form-item
          v-if="activeItemList && (activeItemList.length === 0 || activeItemList.indexOf(item.keyName) > -1)"
          :prop="item.keyName"
          :label="item.label"
          :label-width="formLabelWidth"
        >
          <el-radio-group
            v-if="item.type === 'radio'"
            class="DialogInput"
            v-model="form[item.keyName]"
          >
            <el-radio
              v-for="radioItem in item.children"
              :key="radioItem.keyName"
              :label="radioItem.keyName"
              :value="radioItem.keyName"
            >{{radioItem.label}}</el-radio>
          </el-radio-group>
          <el-select
            v-else-if="item.type === 'select'"
            class="DialogInput"
            filterable
            v-model="form[item.keyName]"
            :placeholder="getPlaceholder(item.label)"
            @change="onSelectChange(item.keyName, item.event)"
            :ref="item.keyName"
            :popper-append-to-body="false"
            @visible-change="(value) => onSelectValue(item.keyName, value)"
          >
            <el-option
              v-for="selectItem in item.children"
              :key="selectItem.keyName"
              :label="selectItem.label"
              :value="selectItem.keyName"
            ></el-option>
          </el-select>
          <el-checkbox-group
            v-else-if="item.type === 'checkbox'"
            class="DialogInput"
            v-model="form[item.keyName]"
          >
            <el-checkbox
              v-for="checkItem in item.children"
              :key="checkItem.keyName"
              :label="checkItem.keyName"
              :value="checkItem.keyName"
            >{{checkItem.label}}</el-checkbox>
          </el-checkbox-group>
          <el-input
            v-else-if="item.type === 'textarea'"
            type="textarea"
            class="DialogInput"
            autocomplete="off"
            :rows="2"
            placeholder="请输入内容"
            v-model="form[item.keyName]"
          ></el-input>
          <el-input-number
            v-else-if="item.type === 'number'"
            v-model="form[item.keyName]"
            autocomplete="off"
            class="DialogInput"
            @change="onSelectChange(item.keyName)"
            :min="item.min || 1"
            :max="item.max || 100000"
          ></el-input-number>
          <div v-else-if="item.type === 'switch'" class="DialogInput">
            <el-switch v-model="form[item.keyName]" class="switchInput"></el-switch>
            <span v-if="form[item.keyName]">已到账</span>
            <span v-else>未到账</span>
          </div>

          <!-- <el-alert
          v-else-if="item.type === 'alert'"
          class="DialogAlert"
          :title="item.alertContent"
          type="warning"
          show-icon
          :closable="false"
          ></el-alert>-->
          <el-date-picker
            v-else-if="item.type === 'datePicker'"
            v-model="form[item.keyName]"
            type="date"
            class="DialogInput"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
          <el-cascader
            v-else-if="item.type === 'cascader'"
            class="DialogInput"
            v-model="form[item.keyName]"
            :options="item.children"
            :props="{ expandTrigger: 'hover' }"
          ></el-cascader>
          <div v-else-if="item.type === 'price'" class="DialogInput">
            <el-input
              v-if="!item.isDisable"
              v-model="form[item.keyName]"
              class="priceInput"
              autocomplete="off"
              @input="onSelectChange(item.keyName)"
            >
              <i slot="suffix" class="priceIcon">元</i>
            </el-input>
            <div class="priceInputTotal" v-else>¥{{form[item.keyName]}}</div>
          </div>
          <el-input
            v-else-if="item.type === 'password'"
            :placeholder="item.placeholder || '请输入密码'"
            v-model="form[item.keyName]"
            autocomplete="off"
            class="DialogInput dialogInputNumber"
            show-password
          ></el-input>
          <el-input
            v-else
            v-model="form[item.keyName]"
            :disabled="item.isDisable"
            class="DialogInput"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <el-alert
      v-if="alertText"
      class="DialogAlert"
      :title="alertText"
      type="warning"
      show-icon
      :closable="false"
    ></el-alert>
  </Dialog>
</template>

<style lang="scss">
.DialogFormContent {
  .DialogForm {
    .DialogInput {
      margin-left: 21px;
      margin-right: 21px;
      width: 82% !important;
      line-height: 37px;

      .el-scrollbar {
        max-height: 350px;
        overflow-y: auto;
      }

      .el-radio__input.is-checked .el-radio__inner {
        border-color: #00c1de;
        background-color: #fff;
      }

      .el-radio__inner::after {
        background-color: #00c1de;
      }

      .el-radio__input.is-checked + .el-radio__label {
        color: #00c1de;
      }

      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #00c1de;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        border-color: #00c1de;
        background-color: #00c1de;
      }

      .el-input.is-active .el-input__inner,
      .el-input__inner:focus {
        border-color: #00c1de;
      }

      .el-input.is-active .el-input__inner,
      .el-input__inner:hover {
        border-color: #00c1de;
      }

      .el-form-item__error {
        left: 25px;
      }

      .el-form-item--small .el-form-item__error {
        left: 25px;
      }
      .el-input-number__decrease {
        height: 30px;
        line-height: 30px;
        margin-top: 3px;
      }
      .el-input-number__increase {
        line-height: 30px;
        margin-top: 3px;
        height: 30px;
      }
      .priceInput {
        width: 100%;
        // margin-right: 10px;
      }

      .switchInput {
        margin-left: 2px;
        margin-right: 10px;
      }

      .priceIcon {
        margin-right: 5px;
      }

      .priceInputTotal {
        width: 97%;
        font-size: 20px;
        margin: auto;
      }
    }

    .el-form-item__error {
      left: 25px;
    }

    .dialogInputNumber {
      .el-input__inner {
        padding-right: 10px;
      }
    }

    margin: 20px 0px 15px;
  }

  .DialogAlert {
    margin: 15px auto;
    width: 306px;
    padding-left: 10px;
    height: 36px;
    background: rgba(255, 251, 230, 1);
    border-radius: 4px;
    border: 1px solid rgba(255, 229, 143, 1);

    .el-alert__title {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 22px;
    }
  }

  .detailTab {
    background-color: #ffffff;
    margin-top: -30px;
    display: flex;
    justify-content: space-around;

    .tab-cell {
      display: inline-block;
      padding: 20px 0;
      text-align: center;
      width: 50%;
      cursor: pointer;
      flex-grow: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/DialogForm.vue